import { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Row, Collapse } from "reactstrap";
// componentes
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ModalImportVehicle from "./ModalImportVehicle";
import ImportUpdateVehicles from "./ImportUpdateVehicles";
import ImportDeleteVehicles from "./ImportDeleteVehicles";
// service
import { getParticipants } from "../../../utils/services/participants";
import { getAllVehicles } from "../../../utils/services/vehicles";

export default function ModalAllImports(props) {
  const { toggle, isOpen, eventId, getAllVehiclesFunc } = props;
  // collapse
  const [collapseCreate, setCollapseCreate] = useState(false);
  const [collapseUpdate, setCollapseUpdate] = useState(false);
  const [collapseDelete, setCollapseDelete] = useState(false);
  // participantes e veiculos do evento
  const [allParticipants, setAllParticipants] = useState([]);
  const [allVehicles, setAllVehicles] = useState([]);

  function toggleCollapseCreate() {
    setCollapseCreate(!collapseCreate);
    setCollapseUpdate(false);
    setCollapseDelete(false);
  }

  function toggleCollapseUpdate() {
    setCollapseCreate(false);
    setCollapseUpdate(!collapseUpdate);
    setCollapseDelete(false);
  }

  function toggleCollapseDelete() {
    setCollapseCreate(false);
    setCollapseUpdate(false);
    setCollapseDelete(!collapseDelete);
  }

  function getAllParticipants() {
    getParticipants({
      idEvent: eventId,
      offset: 1,
      limit: 10000,
      search: "",
      columnSearch: "login",
      status: "ATIVO",
    })
      .then((res) => {
        if (res.message === "users") {
          setAllParticipants(res.data.data);
        }
      })
      .catch((error) => console.log("erro", error));
  }

  function getVehicles() {
    getAllVehicles(eventId, 1, 9999, "", "description").then((res) => {
      if (res.data.message === "FOUND") {
        setAllVehicles(res.data.findAll.data);
      }
    });
  }

  useEffect(() => {
    getAllParticipants();
    getVehicles();
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Importadores de Veículos</ModalHeader>
        <ModalBody>
          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Adicionar Veículos"
              setIsOpen={toggleCollapseCreate}
              isOpen={collapseCreate}
            />
          </Row>

          <Collapse isOpen={collapseCreate}>
            <ModalImportVehicle
              toggle={toggle}
              eventId={eventId}
              getAllVehicles={getAllVehiclesFunc}
              participants={allParticipants}
            />
          </Collapse>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Editar Veículos"
              setIsOpen={toggleCollapseUpdate}
              isOpen={collapseUpdate}
            />
          </Row>

          <Collapse isOpen={collapseUpdate}>
            <ImportUpdateVehicles
              toggle={toggle}
              eventId={eventId}
              getAllVehicles={getAllVehiclesFunc}
              participants={allParticipants}
              allVehicles={allVehicles}
            />
          </Collapse>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Excluir Veículos"
              setIsOpen={toggleCollapseDelete}
              isOpen={collapseDelete}
            />
          </Row>

          <Collapse isOpen={collapseDelete}>
            <ImportDeleteVehicles
              toggle={toggle}
              eventId={eventId}
              getAllVehicles={getAllVehiclesFunc}
              allVehicles={allVehicles}
            />
          </Collapse>
        </ModalBody>
      </Modal>
    </>
  );
}
